import React from 'react';

import { flagStyles } from '../settings';

const SvgNR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4008px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNR;
